import PropTypes from "prop-types"
import React, { useState, useEffect, useRef } from "react"

// //Import Scrollbar
import SimpleBar from "simplebar-react"

// MetisMenu
import MetisMenu from "metismenujs"
import { withRouter } from "react-router-dom"
import { Link } from "react-router-dom"

//i18n
import { withTranslation } from "react-i18next"

import { Collapse } from "reactstrap"

const modules = []

const menus = [
  {
    label: "Dashboard",
    path: "/dashboard",
    icon: "bx bx-home-circle",
    is_tree: false,
    is_parent_label: false,
  },
  {
    label: "Masters",
    is_parent_label: true,
  },
  {
    label: "Company",
    path: "/company",
    icon: "bx bx-buildings",
    is_tree: false,
    is_parent_label: false,
  },
  {
    label: "Subscriptions",
    path: "/subscriptions",
    icon: "bx bx-calendar-check",
    is_tree: false,
    is_parent_label: false,
  },
  {
    label: "Transactions",
    path: "/transactions",
    icon: "bx bx-receipt",
    is_tree: false,
    is_parent_label: false,
  },
  {
    label: "Configurations",
    path: "/configurations",
    icon: "bx bx-cog",
    is_tree: false,
    is_parent_label: false,
  },
  {
    label: "Payment Gateway",
    path: "/payment-gateway-configuration",
    icon: "bx bx-credit-card-front",
    is_tree: false,
    is_parent_label: false,
  },
  {
    label: "Notifications",
    path: "/notifications",
    icon: "bx bx-bell",
    is_tree: false,
    is_parent_label: false,
  },
  {
    label: "Login Ads Management",
    path: "/login-ads-management",
    icon: "bx bx-slideshow",
    is_tree: false,
    is_parent_label: false,
  },
  {
    label: "Universal Templates",
    path: "/universal-templates",
    icon: "bx bx-file",
    is_tree: false,
    is_parent_label: false,
  },
];

const SidebarContent = props => {
  const ref = useRef()
  const [filterMenus, setFilterMenus] = useState(null)
  const [collapsedMenus, setCollapsedMenus] = useState({})

  useEffect(() => {
    let pathName = props.location.pathname

    const initMenu = () => {
      new MetisMenu("#side-menu")
      let matchingMenuItem = null
      const ul = document.getElementById("side-menu")
      const items = ul.getElementsByTagName("a")

      for (let i = 0; i < items.length; ++i) {
        if (pathName == items[i].pathname) {
          matchingMenuItem = items[i]
          break
        }
      }
      if (matchingMenuItem) {
        activateParentDropdown(matchingMenuItem)
      }
    }
    setTimeout(initMenu, 100)
  }, [props.location.pathname])

  useEffect(() => {
    ref.current.recalculate()
  })

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300
      }
    }
  }

  function activateParentDropdown(item) {
    item.classList.add("active")
    const parent = item.parentElement
    const parent2El = parent.childNodes[1]
    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show")
    }

    if (parent) {
      parent.classList.add("mm-active")
      const parent2 = parent.parentElement

      if (parent2) {
        parent2.classList.add("mm-show") // ul tag

        const parent3 = parent2.parentElement // li tag

        if (parent3) {
          parent3.classList.add("mm-active") // li
          parent3.childNodes[0].classList.add("mm-active") //a
          const parent4 = parent3.parentElement // ul
          if (parent4) {
            parent4.classList.add("mm-show") // ul
            const parent5 = parent4.parentElement
            if (parent5) {
              parent5.classList.add("mm-show") // li
              parent5.childNodes[0].classList.add("mm-active") // a tag
            }
          }
        }
      }
      scrollElement(item)
      return false
    }
    scrollElement(item)
    return false
  }

  useEffect(() => {
    setFilterMenus(
      modules?.length
        ? menus.filter(v =>
          modules.map(v => v.toLowerCase()).includes(v.label.toLowerCase())
        )
        : menus
    )
  }, [modules, menus])

  const toggleMenu = menuIndex => {
    setCollapsedMenus({
      ...collapsedMenus,
      [menuIndex]: !collapsedMenus[menuIndex],
    })
  }

  return (
    <React.Fragment>
      <SimpleBar className="h-100" ref={ref}>
        <div id="sidebar-menu" aria-expanded="true">
          <ul className="metismenu list-unstyled" id="side-menu">
            {filterMenus
              ? filterMenus.map((menu, menuIndex) => {
                if (menu.is_parent_label) {
                  return (
                    <li key={`PLI_${menuIndex}`} className="menu-title">
                      {props.t(menu.label)}
                    </li>
                  )
                } else {
                  const isActive = props.location.pathname === menu.path
                  return (
                    <li key={`PLI_${menuIndex}`} className={isActive ? "mm-active" : ""}>
                      <Link
                        to={menu?.path}
                        className={`${menu.is_tree ? "has-arrow" : ""} ${isActive ? "active mm-active" : ""}`}
                        onClick={() => menu.is_tree && toggleMenu(menuIndex)}
                      >
                        <i className={`${menu.icon}`} />
                        <span>{props.t(menu.label)}</span>
                      </Link>
                      {menu.is_tree && (
                        <Collapse isOpen={collapsedMenus[menuIndex]}>
                          <ul className="sub-menu" aria-expanded="false">
                            {menu?.sub?.map((sub_menu, submenuIndex) => (
                              <li key={`SMPLI_${submenuIndex}`}>
                                <Link to={sub_menu.path}>
                                  {props.t(sub_menu.label)}
                                </Link>
                              </li>
                            ))}
                          </ul>
                        </Collapse>
                      )}
                    </li>
                  )
                }
              })
              : "loading..."}
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  )
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
}

export default withRouter(withTranslation()(SidebarContent))
